import APP from 'src/main.js'
import AppRecord from './AppRecord.js'

class SailsLog extends AppRecord {
  get recordName(){
    if (this.sails_log_details){    
      if (this.sails_log_details[0].reference_type == "Client"){
        return "Person"
      }

      return this.sails_log_details[0].reference_type
    }

    return ''
  }

  get recordId(){
    if (this.sails_log_details){    
      return this.sails_log_details[0].reference_id
    }

    return null
  }

  controller(){
    if (this.sails_log_details){
      const recordName = this.recordName
     
      const controller = Object.values(this.constructor.employeeStore.controllers).find(contr => contr.object_name === recordName.toLowerCase())
      return controller
    }

    return null
  }
}

export default SailsLog
